import { useNotification } from "app/NotificationProvider";
import { analytics, AnalyticsEvents } from "common/analytics";
import EventFileUpload from "common/components/EventFileUpload";
import EventFormDialog from "common/components/EventFormDialog";
import { useTranslation } from "common/locales";
import { FieldPreparationEvent, useUpdateFieldPreparationEvent } from "model";
import { Dispatch, SetStateAction, useRef } from "react";
import EnterFieldPreparationEvent from "./EnterFieldPreparationEvent";
import {
  convertFromFormInput,
  FieldPreparationEventFormData,
} from "./FieldPreparationEventFormData";

export default function UpdateFieldPreparationEvent({
  fieldPreparationEvent,
  dialogOpen,
  setDialogOpen,
}: {
  fieldPreparationEvent: FieldPreparationEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const { notify } = useNotification();
  const { t } = useTranslation();
  const updateFieldPreparationEventMutation = useUpdateFieldPreparationEvent();
  const dirtyRef = useRef(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  async function handleSave(
    fieldPreparationEventFormData: FieldPreparationEventFormData
  ) {
    const convertedFieldPreparationEvent = convertFromFormInput(
      fieldPreparationEventFormData
    );
    await updateFieldPreparationEventMutation.mutateAsync({
      fieldPreparationEvent: {
        ...convertedFieldPreparationEvent,
        guid: fieldPreparationEvent.guid,
      },
    });
    notify(t("addOtherEvent.update.success"));
    analytics.track(AnalyticsEvents.OTHER_EVENT_UPDATED);
    handleClose();
  }

  return (
    <EnterFieldPreparationEvent
      fieldPreparationEvent={fieldPreparationEvent}
      handleSave={handleSave}
      fieldSelectDisabled={false}
      dirtyRef={dirtyRef}
      fileUploadSlot={
        <EventFileUpload farmEventGuid={fieldPreparationEvent.guid} />
      }
    >
      {({ steps, submitForm }) => (
        <EventFormDialog
          open={dialogOpen}
          onClose={handleClose}
          title={t("otherEventInput.title")}
          onSave={submitForm}
          isDirty={() => dirtyRef.current}
          cancelAnalyticsEvent={AnalyticsEvents.OTHER_EVENT_UPDATE_CANCELLED}
          steps={steps}
        />
      )}
    </EnterFieldPreparationEvent>
  );
}
